// id strings for messages/upsell.ts. Same keys and {variables} as en there.
import type { Dict } from "../index";

const upsell: Dict = {
  // Creator sheet, per reason: headline, lead, ticks, button.
  "upsell.creator.train.title": "Mulai melatih suara dengan Creator",
  "upsell.creator.train.lead": "Fitur latih suara tersedia di Creator.",
  "upsell.creator.train.tick1": "Latih suara tanpa batas",
  "upsell.creator.train.tick2": "Video Marble Run, 50 koin per bulan",
  "upsell.creator.train.tick3": "Semua fitur paketmu tetap ada",
  "upsell.creator.train.cta": "Upgrade dan mulai melatih",

  "upsell.creator.export.title": "Ekspor dalam 1080p",
  "upsell.creator.export.lead":
    "Dengan Creator, videomu diekspor dalam 1080p penuh.",
  "upsell.creator.export.tick1": "Ekspor 1080p",
  "upsell.creator.export.tick2": "Video Marble Run, 50 koin per bulan",
  "upsell.creator.export.tick3": "Latih suara tanpa batas",
  "upsell.creator.export.cta": "Upgrade dan ekspor 1080p",

  "upsell.creator.marble.title": "Marble Run ada di Creator",
  "upsell.creator.marble.lead":
    "Ubah covermu jadi video Marble Run, siap untuk TikTok dan Reels.",
  "upsell.creator.marble.tick1": "50 koin Marble Run setiap bulan",
  "upsell.creator.marble.tick2": "Ekspor studio 1080p",
  "upsell.creator.marble.tick3": "Latih suara tanpa batas",
  "upsell.creator.marble.cta": "Upgrade dan buat Marble Run",

  "upsell.creator.video.title": "Video ada di Creator",
  "upsell.creator.video.lead":
    "Ubah covermu jadi video yang siap dibagikan ke TikTok dan Reels.",
  "upsell.creator.video.tick1": "Video siap dibagikan, 50 koin per bulan",
  "upsell.creator.video.tick2": "Ekspor studio 1080p",
  "upsell.creator.video.tick3": "Latih suara tanpa batas",
  "upsell.creator.video.cta": "Upgrade dan buat videoku",

  // Creator sheet, shared.
  "upsell.creator.samplesOne":
    "Rekaman vokalmu sudah siap: {files} file, {duration}. ",
  "upsell.creator.samplesMany":
    "Rekaman vokalmu sudah siap: {files} file, {duration}. ",
  "upsell.creator.nothing": "Tidak ada",
  "upsell.creator.today": "hari ini",
  "upsell.creator.toPayToday": "tagihan hari ini",
  "upsell.creator.thenMonth": "lalu {price} per bulan",
  "upsell.creator.credited":
    "Sisa bulan berjalanmu diperhitungkan. Bisa dibatalkan kapan saja.",
  "upsell.creator.priceError":
    "Harga upgrade gagal dimuat. Kamu bisa upgrade kapan saja dari Pengaturan.",
  "upsell.creator.upgrading": "Sedang upgrade...",
  "upsell.creator.notNow": "Nanti saja",
  "upsell.creator.payFailed":
    "Pembayaran tidak berhasil, jadi tidak ada yang berubah. Cek kartumu di Pengaturan lalu coba lagi.",

  // Pro Coin packs.
  "upsell.coins.title": "Dapatkan Pro Coin",
  "upsell.coins.subtitle": "Setiap koin membuat satu video siap dibagikan",
  "upsell.coins.coinAlt": "Pro Coin",
  "upsell.coins.useMarble": "Video Marble Run",
  "upsell.coins.useLyric": "Video Lirik",
  "upsell.coins.useTemplates": "Semua Template Video",
  "upsell.coins.bestValue": "PALING HEMAT",
  "upsell.coins.mostCoins": "KOIN TERBANYAK",
  "upsell.coins.proCoins": "pro coin",
  "upsell.coins.each": "{price}/koin",
  "upsell.coins.purchase": "Beli",
  "upsell.coins.footer":
    "Pro Coin langsung masuk dan tidak pernah kedaluwarsa. 1 koin = 1 video.",
};

export default upsell;
